import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

export const NotFound: React.FC = () => {
  return (
    <Alert severity='error'>
      <AlertTitle>Error</AlertTitle>
      Page Not Found
    </Alert>
  );
};
